import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { getCalendarPostback } from './utils/LinePostbackActions';

const LexusCalenderPage = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const payload = { token: searchParams.get('token') };

    const sendPostback = async () => {
      try {
        const calendarData = await getCalendarPostback(payload);

        const blobData = new Blob([calendarData], {
          type: 'text/calendar',
        });
        const url = window.URL.createObjectURL(blobData);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'event_calendar.ics';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.error(err);
        alert(`Error occurred while connect to server`);
      }
    };

    sendPostback();
  }, [searchParams]);

  return <div></div>;
};

export default LexusCalenderPage;
